import { CARD_ENCRYPTION_SECRET_KEY, ENCRYPTED_SYMMETRICK_KEY_ENPOINT, REALM_PATH, SPA_ENCRYPTION_SECRET_KEY } from "@/config/constants";
import cryptoJS from "crypto-js";
import { getEncryptedSymmetricKey } from "../apiService.service";
import { store } from "../../store/configureStore";
import { datadogLogs } from "@datadog/browser-logs";
var forge = require('node-forge');
let encryptedSymmetricKey: string = ""
let decryptedSymmetricKey: string = "";

export const encryptToken = (token: any) => {
  return token;
};

export const decryptToken = (token: any) => {
  return token;
};

export const encryptData = (
  data: any,
  encryptionKey: string = CARD_ENCRYPTION_SECRET_KEY
): string => {
  const encryptedData = cryptoJS.AES.encrypt(data, encryptionKey).toString();
  return encryptedData;
};

export const decryptData = (
  data: any,
  decryptionKey: string = CARD_ENCRYPTION_SECRET_KEY
): any => {
  let bytes = cryptoJS.AES.decrypt(data, decryptionKey);
  let decryptedData = JSON.parse(bytes.toString(cryptoJS.enc.Utf8));
  return decryptedData;
};

/* Decrypts an encrypted symmetric key using RSA private key
returns Decrypted symmetric key as a UTF-8 string.
*/
export const decryptSymmetricKey = (symmetricKey: string) => {
  try {
      encryptedSymmetricKey = symmetricKey;
      const privateKey = forge.pki.privateKeyFromPem(SPA_ENCRYPTION_SECRET_KEY.split(String.raw`\n`).join('\n'));
      const decoded = forge.util.decode64(symmetricKey);
      decryptedSymmetricKey = privateKey.decrypt(decoded, 'RSA-OAEP', {
          md: forge.md.sha256.create()
        });
      return decryptedSymmetricKey;
  } catch (error) {
    datadogLogs.logger.error(`SymmetricKey: decryptSymmetricKey error - ${store.getState().user?.account?.PersonEmail} ${JSON.stringify(error)}`);
  }
}

export const encryptDataWithDecryptedKey = (data: any) : string => {
  const encryptedData = (cryptoJS.AES.encrypt(JSON.stringify(data), decryptedSymmetricKey)).toString();
  return encryptedData
}

export const decryptDataWithDecryptedKey = (data: any) : string => {
  const bytes = cryptoJS.AES.decrypt(data, decryptedSymmetricKey);
  const decryptedData = JSON.parse(bytes.toString(cryptoJS.enc.Utf8));
  return decryptedData
}

export const getCurrentEncryptedSymmetricKey = () => {
  return encryptedSymmetricKey;
}

export const fetchEncryptedSymmetricKey = async (endPoint: string = ENCRYPTED_SYMMETRICK_KEY_ENPOINT) => {
  const encryptedSymmetricKeyPromise = new Promise(async (resolve, reject) => {
    try {
      const encryptedSymmetricKeyResponse: any = await getEncryptedSymmetricKey({
        "referenceId": store.getState().user?.account?.PersonEmail,
        "customerId": store.getState().user?.account?.Id
      },
      store.getState().user?.token,
      endPoint
    );
      const encryptedSymmetricKey = encryptedSymmetricKeyResponse.data.keyBlob;
      decryptSymmetricKey(encryptedSymmetricKey);
      resolve(encryptedSymmetricKeyResponse)
    } catch(error) {
      datadogLogs.logger.error(`SymmetricKey: fetchEncryptedSymmetricKey error - ${store.getState().user?.account?.PersonEmail} ${JSON.stringify(error)}`);
      reject(error);
    }
  });
  return encryptedSymmetricKeyPromise;
}